var GSM_7BIT_REGEXP = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà]*$/;
var GSM_7BIT_EXT_REGEXP = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~\]|€]*$/;
var GSM_7BIT_EXT_CHAR_REGEXP = /^[\^{}\\[~\]|€]$/;
var messageLength = {
  GSM_7BIT: 160,
  GSM_7BIT_EXT: 160,
  UTF16: 70
};
var multiMessageLength = {
  GSM_7BIT: 153,
  GSM_7BIT_EXT: 153,
  UTF16: 67
};
var count = function count(text) {
  var encoding = detectEncoding(text);
  var length = text.length;

  if (encoding === "GSM_7BIT_EXT") {
    length += countGsm7bitExt(text);
  }

  var characterPerMessage = messageLength[encoding];

  if (length > characterPerMessage) {
    characterPerMessage = multiMessageLength[encoding];
  }

  var messages = Math.ceil(length / characterPerMessage);
  var inCurrentMessage = length;

  if (messages > 0) {
    inCurrentMessage = length - characterPerMessage * (messages - 1);
  }

  var remaining = characterPerMessage * messages - length;

  if (remaining === 0 && messages === 0) {
    remaining = characterPerMessage;
  }

  return {
    encoding: encoding,
    length: length,
    characterPerMessage: characterPerMessage,
    inCurrentMessage: inCurrentMessage,
    remaining: remaining,
    messages: messages
  };
};

var detectEncoding = function detectEncoding(text) {
  switch (false) {
    case text.match(GSM_7BIT_REGEXP) == null:
      return "GSM_7BIT";

    case text.match(GSM_7BIT_EXT_REGEXP) == null:
      return "GSM_7BIT_EXT";

    default:
      return "UTF16";
  }
};

var countGsm7bitExt = function countGsm7bitExt(text) {
  var extChar = [];

  for (var i = 0; i < text.length; i++) {
    var _char = text[i];

    if ((_char.match(GSM_7BIT_EXT_CHAR_REGEXP) || []).length > 0) {
      extChar.push(_char);
    }
  }

  return extChar.length;
};

export { count };
//# sourceMappingURL=sms-length.esm.js.map
